import React from 'react';
import { Table, TableRow, TableCell, TableBody, Skeleton } from '@mui/material';
import MainCard from 'components/MainCard';

type RowProps = {
  columns: number;
};

type TableProps = {
  rows: number;
  columns: number;
};
const ShimmerTableRow: React.FC<RowProps> = ({ columns }) => (
  <TableRow>
    {Array(columns)
      .fill(null)
      .map((_, index) => (
        <TableCell key={index}>
          <Skeleton />
        </TableCell>
      ))}
  </TableRow>
);

const ShimmerTable: React.FC<TableProps> = ({ rows, columns }) => (
  <MainCard>
    <Table>
      <TableBody>
        {Array(rows)
          .fill(null)
          .map((_, index) => (
            <ShimmerTableRow key={index} columns={columns} />
          ))}
      </TableBody>
    </Table>
  </MainCard>
);

export default ShimmerTable;
